import { cn } from '@/lib/utils'

/** Edge-line texture matching the page chrome, in the footer's dark palette. */
export function FooterEdgeLine({ side }: { side: 'left' | 'right' }) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'pointer-events-none absolute inset-y-0 z-10000 w-[7px] bg-[linear-gradient(to_right,var(--n-500)_0,var(--n-500)_1px,transparent_1px,transparent_3px,var(--n-700)_3px,var(--n-700)_7px)]',
        side === 'left'
          ? 'left-[max(0px,calc((100%-var(--maxw))/2-24px))]'
          : 'right-[max(0px,calc((100%-var(--maxw))/2-24px))]'
      )}
    />
  )
}
